import BasicHero from "@cs/screens/olympiad/hero/BasicHero";
import HeroBackground from "@cs/public/img/olympiad/countries/countries_hero.jpg";
import HeroBackgroundMobile from "@cs/public/img/olympiad/countries/countries_hero_mobile.jpg";
import HeroBackgroundSmallMobile from "@cs/public/img/olympiad/countries/countries_hero_small_mobile.jpg";
import { useTranslation } from "next-i18next";
import { useDeviceSize } from "@climate-science/component-library";
import styles from "../../../OlympiadGeneralStyles.module.scss"

const CountriesHero = () => {
  const {isSmallMobile, isMobile} = useDeviceSize()
  const {t} = useTranslation("olympiad")
 
  const background = {
    src: HeroBackground,
    alt: "Planet Earthly"
  }

  if (isMobile) {
    background.src = HeroBackgroundMobile
  }
  
  if (isSmallMobile) {
    background.src = HeroBackgroundSmallMobile
  }

  return (
    <BasicHero
      background={background}
      ns={"olympiad"}
      heading={"countries.hero-header"}
      footer={"countries.hero-footer"}
    >
      <p className={styles.p}>
        {t("countries.hero-content")}
      </p>
    </BasicHero>
  )
}


export default CountriesHero